import { FAQ_OPEN } from '../app/ActionsConst';
import { buildAndShowErrorToast } from '../app/core/actions/toast/ToastActions';
import { getActionErrorMessage } from '../app/services/error/ErrorService';
import { openFaq } from '../app/services/faq/FaqService';
import messages from '../data/help';

export const faqMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case FAQ_OPEN:
      try {
        openFaq();
      } catch (e) {
        const { defaultMessage } = messages.helpPagePopUpError;
        store.dispatch(buildAndShowErrorToast(getActionErrorMessage(action, defaultMessage)));
      }
      break;
    default:
    // Do nothing
  }
  return next(action);
};
